import { questionService } from './../services/question.service';
import { FormBuilder } from '@angular/forms';
import { AuthenticationService, TestData } from '../services/authentication.service';
import { Router } from '@angular/router';
import { QuestionSetService, collegequestionset } from '../services/questionset.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { TestSchedulerService } from '../services/test_scheduler.service';
// import { Overall_Result } from './overall_result.model';
import { CollegeService, College_Names, Student_scheduleid } from '../services/College_name.service';
import { YearService } from '../services/year.service';
import { Schedule } from '../scheduletest/scheduletest.model';
import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, Pipe, PipeTransform, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { report, ReportService } from '../services/report.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { RowEditingDirectiveBase } from '@progress/kendo-angular-grid';
import {ChangePipe} from '../replace_function';
import { userDetailsService } from '../services/user.details.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { isEmpty } from 'lodash';
@Component({
  selector: 'app-testtaker-report',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './testtaker-report.component.html',
  styleUrls: ['./testtaker-report.component.scss']
})
export class TesttakerReportComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) matsort: MatSort;
  @ViewChild(MatPaginator, { static: true }) matpaginator: MatPaginator;
  @ViewChild("content") modalContent: TemplateRef<any>;
  @ViewChild('pdfExport') pdfExport: PDFExportComponent;

  // @Output() studentdata = new EventEmitter();
  question_set: collegequestionset = { collegeid: '', yearid: '' }
  displayedColumns: string[] = ['S.No.', 'First_Name', 'Total_Score', 'View' ,'View Questions'];
  report_details: report = { College_Id: '', Year_Id: '', Question_Set: '' };
  student_id:Student_scheduleid={user_id:'',schedule_id:''}
  searchKey: string;
  datasource: MatTableDataSource<any>;
  fieldArray: Array<Schedule> = [];
  selectedCategory;
  selectedCategoryindex: string;
  newAttribute: any = {};
  Question_Category: any;
  result: boolean;
  details: boolean;
  Category;
  Type;
  Complexity;
  complexityId: string;
  fname;
  lname;
  user;
  i: any;
  userAdmin: boolean;
  imageUrlArray:[]
  overall: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  questionset: boolean;
  scheduletest: boolean;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  //overall_result: Array<Overall_Result> = [];
  evaluate: boolean;
  report;
  college_set: College_Names = {
    college_name: ''
  }
  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };
  selectedindex: any;
  selectedcollegeset: any;
  collegeid: any;
  Year: any;
  yearid: any;
  college: any;
  reportdetails: any;
  data: boolean = true;
  selectedyearset: any;
  year_id: any;
  qset: any;
  reportdetailss: any;
  result_details: any;
  columns: string[];
  scheduleid: any;
  selectedquestionset: any;
  correct: boolean;
  incorrect: boolean;
  // student_id: Student_scheduleid = { user_id: '', schedule_id: '' }
  //route: any;
  //student_id: any;
  id: any;
  // scheduleid: any;
  rollnumber: any;
  firstname: any;
  college_name: any;
  questions_ready: boolean;
  studentdata: any;
  questionpdf: boolean;
  modalRef: any;
  currentYear: any = new Date().getFullYear()
  imageUrl: any;

  constructor(private fb: FormBuilder, private auth: AuthenticationService, private router: Router, private qs: QuestionSetService, private reportservice: ReportService,
    private testschedulerservice: TestSchedulerService, media: MediaMatcher, private fs: CollegeService, private ys: YearService,private modal: NgbModal,
    private userDetails: userDetailsService,private sanitizer: DomSanitizer) {
    this.simpletest();

    //this.overallresult();
    this.CollegeName();
    
    this.mobileQuery = media.matchMedia('(max-width: 600px)');

    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {
    this.columns = this.auth.getColumnsB();
    this.getTempRowData();
    
  }
  simpletest() {
    this.testschedulerservice.test_scheduler(this.test).subscribe(
      (data) => {

        this.user = sessionStorage.getItem('user');
        this.fname = sessionStorage.getItem('fname');

        this.lname = sessionStorage.getItem('lname');


      },
      err => {
        console.error(err);
      }
    );
  }
  getTempRowData() {
    this.newAttribute = { college_name: '', academic_year: '', questionsetname: '', pattern: '', date: '', start_time: '', end_time: '', paperlist: '', scheduler: '' };

    this.fieldArray.push(this.newAttribute);
  }


  selectChangeHandler1(event: any, i: any) {

    this.selectedindex = i;

    this.selectedcollegeset = event.target.value;
    console.log(event.target.value)
    this.collegeid = this.selectedcollegeset;
    localStorage.setItem('CollegeId', this.collegeid)
    this.ys.academicyear(this.selectedcollegeset).subscribe(
      (data) => {

        this.Year = data.results;
        let value = data.results
        console.log(value);
        this.fieldArray[i].academic_year = value;
        console.log(this.fieldArray)

        //
        console.log(data.results)
        this.yearid = this.Year[0].Id

        localStorage.setItem('Yearid', this.yearid)
      },
      err => {
        console.error(err);
      }
    );
  }

  selectChangeHandler2(event: any, i: any) {

    this.selectedindex = i;

    this.selectedyearset = event.target.value;
    console.log(event.target.value)
    this.year_id = this.selectedyearset;
    localStorage.setItem('CollegeId', this.collegeid)
    this.question_set.collegeid = this.collegeid;
    this.question_set.yearid = this.year_id
    this.qs.college_questionset(this.question_set).subscribe(
      (data) => {

        this.result = data.results;
        console.log(data.results)
        this.qset = this.result[0].Id;
        localStorage.setItem('qsid', this.qset);
        //this.questionsetid=this.result[0].Id
    

      },
      err => {
        console.error(err);
      }
    );
  }

  selectQuestionSet(event: any, i: any) {

    this.selectedindex = i;
    
    this.selectedquestionset = event.target.value;
    console.log(this.selectedquestionset)

  }

  CollegeName() {
    this.fs.College_Name(this.college_set).subscribe(
      (data) => {

        this.college = data.results;


      },
      err => {
        console.error(err);
      }
    );
  }

  //Show Report
  showreport() {
    console.log("inside show report")

    this.data = false;
    this.report_details.College_Id = this.collegeid;
    this.report_details.Year_Id = this.yearid;
    this.report_details.Question_Set = this.qset;

   console.log(this.report_details);


    this.reportservice.candidate_report(this.report_details).subscribe(
      (data) => {

        this.result_details = data.results;
        this.datasource = new MatTableDataSource(this.result_details);
        this.datasource.sort = this.matsort;
        setTimeout(() => this.datasource.paginator = this.matpaginator);
      },
      err => {
        console.error(err);
      }
    );
  }
  //   download_csv() {
  // var csv = '\n';
  // data.forEach(function(row) {
  //         csv += row.join(',');
  //         csv += "\n";
  // });

  //
  // var hiddenElement = document.createElement('a');
  // hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
  // hiddenElement.target = '_blank';
  // hiddenElement.download = 'name.csv';
  // hiddenElement.click();
  // }


  view(row) {
    this.student_id.user_id = row.Test_Taker_User_Id;
    this.student_id.schedule_id = row.Schedule_id;
    this.fs.sharedData(this.student_id)

    sessionStorage.setItem('studentdata',JSON.stringify(this.student_id));
    // this.studentdata.emit(this.student_id);
    this.router.navigate(['/individual_result']);
  }
  viewquestions(row){
    this.student_id.user_id = row.Test_Taker_User_Id;
    this.student_id.schedule_id = row.Schedule_id;
    sessionStorage.setItem('studentdata',JSON.stringify(this.student_id));

    this.questionpdf=true;
    // this.router.navigate(['/questionpdfexport']);
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalRef = this.modal.open(this.modalContent, ngbModalOptions)
    this.view_questions(row);
  }


  beforeExport(e: any): void {
    console.log("inside beforeExport")
    // Add your logic before exporting to PDF

    const extraPageContent = `
      <div>
        <!-- Content for the extra page -->
        <h2>Extra Page</h2>
        <img src="path/to/image.png" alt="Image" />
      </div>
    `;

    // Add an extra page with custom content
    e.sender.append(extraPageContent);
    
    // Export the modified PDF
    e.preventDefault(); // Prevent default export
    e.sender.saveAs().then(() => {
      // Reset the PDF export component after export is completed
      console.log("export completed")
    });
  }


  

  view_questions(row) {
    // this.studentdata=JSON.parse(sessionStorage.getItem('studentdata'));
    this.student_id.user_id = row.Test_Taker_User_Id;
    this.student_id.schedule_id = row.Schedule_id;
    console.log("this.student_id",this.student_id)
    this.fs.Student_Schedule_Id(this.student_id).subscribe(
      (data) => {

        console.log("data",data)
        this.scheduleid = data.results;


        this.rollnumber = this.scheduleid[0].Roll_Number;
        if(isEmpty(this.scheduleid[0].Last_Name))
        {
          this.firstname = this.scheduleid[0].First_Name
        }
        else
        {
          this.firstname = this.scheduleid[0].First_Name + " " + this.scheduleid[0].Last_Name;
        }      
        this.college_name = this.scheduleid[0].College_Name;

        this.view_question_pdf();
      },
      err => {
        console.error(err);
      }
    );
    this.userDetails.getUserDetails(this.student_id.user_id, true).subscribe(
      (data) => {
        console.log("this.data",data)
        console.log("data.Datareturned[0].Image_URL",data.Datareturned[0].Image_URL)
        let imageUrlArray = data.Datareturned[0].Image_URL.split('@@@')
        this.imageUrl = imageUrlArray[0]
        this.imageUrlArray = data.Datareturned[0].Image_URL.split('@@@')
        this.imageUrlArray.shift()

      }) 

  }

  

  view_question_pdf() {
    this.studentdata=JSON.parse(sessionStorage.getItem('studentdata'));

    this.student_id.schedule_id =  this.studentdata.schedule_id;
    this.student_id.user_id =  this.studentdata.user_id;
    this.fs.Questionpdf(this.student_id).subscribe(
      (data) => {
        console.log("data.results************",data.sortedResults)

        this.scheduleid = data.sortedResults;


        this.student_id.user_id = this.id
        this.student_id.schedule_id = this.scheduleid[0].Id;
        this.convert()
        this.questions_ready = true;

      },
      err => {
        console.error(err);
      }
    );


  }

  back() {
    this.router.navigate(['/overall_result']);
  }
  convert() {
    for (var i = 0; i < this.scheduleid.length; i++) {
      MathJax.Hub.Config({
        showMathMenu: false,
        tex2jax: { inlineMath: [['$', '$'], ['\\(', '\\)']] },
        menuSettings: { zoom: "Double-Click", zscale: "150%" },
        CommonHTML: { linebreaks: { automatic: true } },
        "HTML-CSS": { scale: 100, linebreaks: { automatic: true, width: "container" } },
        SVG: { linebreaks: { automatic: true } }
      });
      setTimeout(() => {
        MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.getElementsByClassName("answers")]);
      }, 3000)
    }
  }

  onSearchClear() {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter() {
    this.datasource.filter = this.searchKey.trim().toLowerCase();
  }

  //get candidate report, populate into excel sheet and save it in temp_report table(group_concat method)
  downloadFile() {
    // this.data=true;
    this.report_details.College_Id = this.collegeid;
    this.report_details.Year_Id = this.yearid;
    this.report_details.Question_Set = this.qset;



    console.log(this.report_details);
    this.reportservice.download_report(this.report_details).subscribe(
      (data) => {

        this.reportdetailss = data.results;

        this.download_csv();

      },
      err => {
        console.error(err);
      }
    );
  }

  //download data from temp_report table
  download_csv() {
    console.log("inside download csv testtaker")
    // this.data=true;
    this.report_details.College_Id = this.collegeid;
    this.report_details.Year_Id = this.yearid;
    this.report_details.Question_Set = this.qset;




    this.reportservice.download_csv(this.report_details,[]).subscribe(
      (data) => {


        var csv = '';
        data.results.forEach((row) => {


          var array = Object.values(row);

          csv += array.join(',');
          csv += "\n";
        });


        var hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
        hiddenElement.target = '_blank';
        hiddenElement.download = 'test_report.csv';
        hiddenElement.click();
      },
      err => {
        console.error(err);
      }
    );
  }
}

/*@Pipe({name: 'replace'})
export class ReplacePipe implements PipeTransform {
  transform(value: string): string {

    let newValue = value.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    return `${newValue}`;
  }
}*/
export var replace=new ChangePipe();